import { createSlice } from '@reduxjs/toolkit';
import { showApiErrors } from '@/utils';
import { getLLMTemplateVariables } from './actionCreators';
import { LLMTemplateVariablesState, SLICE_NAME, initialState } from './models';

export const llmTemplateVariablesSlice = createSlice({
  name: SLICE_NAME,
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getLLMTemplateVariables.pending, (state: LLMTemplateVariablesState) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(getLLMTemplateVariables.fulfilled, (state: LLMTemplateVariablesState, action) => {
        const { payload } = action;
        state.isLoading = false;
        state.variables = payload;
      })
      .addCase(getLLMTemplateVariables.rejected, (state: LLMTemplateVariablesState, action) => {
        const { error } = action;
        state.isLoading = false;
        state.error = error;
        showApiErrors(error);
      });
  },
});
